var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7655 39.3886C15.7655 42.6264 13.1205 45.2713 9.88274 45.2713C6.64495 45.2713 4 42.6264 4 39.3886C4 36.1508 6.64495 33.5059 9.88274 33.5059H15.7655V39.3886Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7295 39.3886C18.7295 36.1508 21.3744 33.5059 24.6122 33.5059C27.85 33.5059 30.495 36.1508 30.495 39.3886V54.1182C30.495 57.356 27.85 60.001 24.6122 60.001C21.3744 60.001 18.7295 57.356 18.7295 54.1182V39.3886Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6122 15.7655C21.3744 15.7655 18.7295 13.1205 18.7295 9.88274C18.7295 6.64495 21.3744 4 24.6122 4C27.85 4 30.495 6.64495 30.495 9.88274V15.7655H24.6122Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6124 18.7305C27.8502 18.7305 30.4951 21.3754 30.4951 24.6132C30.4951 27.851 27.8502 30.4959 24.6124 30.4959H9.88274C6.64495 30.4959 4 27.851 4 24.6132C4 21.3754 6.64495 18.7305 9.88274 18.7305H24.6124Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2344 24.6132C48.2344 21.3754 50.8793 18.7305 54.1171 18.7305C57.3549 18.7305 59.9998 21.3754 59.9998 24.6132C59.9998 27.851 57.3549 30.4959 54.1171 30.4959H48.2344V24.6132Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2704 24.6124C45.2704 27.8502 42.6254 30.4951 39.3876 30.4951C36.1498 30.4951 33.5049 27.8502 33.5049 24.6124V9.88274C33.5049 6.64495 36.1498 4 39.3876 4C42.6254 4 45.2704 6.64495 45.2704 9.88274V24.6124Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3876 48.2363C42.6254 48.2363 45.2704 50.8813 45.2704 54.1191C45.2704 57.3568 42.6254 60.0018 39.3876 60.0018C36.1498 60.0018 33.5049 57.3568 33.5049 54.1191V48.2363H39.3876Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3876 45.2713C36.1498 45.2713 33.5049 42.6264 33.5049 39.3886C33.5049 36.1508 36.1498 33.5059 39.3876 33.5059H54.1173C57.355 33.5059 60 36.1508 60 39.3886C60 42.6264 57.355 45.2713 54.1173 45.2713H39.3876Z",
    fill: "#ECB22E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.9e6c46b9176f74fb53e1716213b1323b.svg";
export { ForwardRef as ReactComponent };